import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Mail, Phone, MapPin } from 'lucide-react';

const footerLinks = {
  Platform: [
    { label: 'About', href: '/about' },
    { label: 'Categories', href: '/categories' },
    { label: 'Timeline', href: '/timeline' },
    { label: 'Winners Gallery', href: '/winners' },
    { label: 'Sponsors', href: '/sponsors' },
  ],
  Participate: [
    { label: 'Join Now', href: '/register' },
    { label: 'Sign In', href: '/login' },
    { label: 'Rules & Guidelines', href: '/rules' },
    { label: 'FAQ', href: '/faq' },
    { label: 'Contact Us', href: '/contact' },
  ],
  Legal: [
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Terms & Conditions', href: '/terms' },
    { label: 'Refund Policy', href: '/refund-policy' },
  ],
};

const socialLinks = [
  { label: 'IG', title: 'Instagram', href: '#' },
  { label: 'YT', title: 'YouTube', href: '#' },
  { label: 'TW', title: 'Twitter/X', href: '#' },
];

export default function HomeFooter() {
  return (
    <footer className="border-t border-gold-subtle" style={{ background: 'rgba(10,10,10,0.98)' }}>
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-2 lg:grid-cols-6 gap-10 mb-12">
          {/* Brand column */}
          <div className="col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <AppLogo size={40} />
              <div>
                <span className="font-extrabold text-lg gradient-gold-text block leading-tight">Motion Max</span>
                <span className="text-xs text-muted-foreground">Media Awards</span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed mb-5 max-w-xs">
              India&apos;s premier media awards platform celebrating extraordinary storytelling talent across film, reels, and digital media.
            </p>
            <div className="space-y-2 mb-5">
              <a href="mailto:awards@motionmax.in" className="flex items-center gap-2 text-xs text-muted-foreground hover:text-primary transition-colors">
                <Mail size={13} className="text-primary/60" /> awards@motionmax.in
              </a>
              <a href="tel:+919840012345" className="flex items-center gap-2 text-xs text-muted-foreground hover:text-primary transition-colors">
                <Phone size={13} className="text-primary/60" /> +91 98400 12345
              </a>
              <p className="flex items-center gap-2 text-xs text-muted-foreground">
                <MapPin size={13} className="text-primary/60" /> Chennai, Tamil Nadu, India
              </p>
            </div>
            {/* Social */}
            <div className="flex items-center gap-3">
              {socialLinks?.map((s) => (
                <a
                  key={s?.title}
                  href={s?.href}
                  aria-label={s?.title}
                  className="w-9 h-9 rounded-xl glass-card flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/40 transition-all text-xs font-bold"
                >
                  {s?.label}
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks)?.map(([group, links]) => (
            <div key={`footer-group-${group}`}>
              <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-4">{group}</p>
              <ul className="space-y-2.5">
                {links?.map((link) => (
                  <li key={`footer-link-${link?.label}`}>
                    <Link href={link?.href} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gold-subtle pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-muted-foreground/60">
              © 2026 Motion Max Media Awards. All rights reserved. Made with ♥ in Chennai.
            </p>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-success animate-pulse" />
              <span className="text-xs text-muted-foreground/60">Season 3 submissions open</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}